import { Stack } from '@mui/material'
import { FC } from 'react'

const StackDefault: FC = (props) => {
    return <Stack spacing={3} {...props} />
}

export default StackDefault
